<header class="header" [class.header-opened]="headerOpened">
  <div class="container container_type_header">
    <a routerLink="/" class="logo">
      <span class="logo__text">{{ 'header.title' | translate }}</span>
    </a>
    <div class="header__search">
      <div class="input input_width_auto input_size_m">
        <div class="input__container">
          <div class="input__icon icon-search"></div>
          <input type="text" placeholder="{{ 'header.search-placeholder' | translate }}" class="input__input" (click)="openHeader()"
                 [value]="searchText"
                 (keydown)="onKeyDown($event)"
                 (input)="onInputChange($event)" (keyup.enter)="search()" (keyup.shift.enter)="search()" maxlength="100"/>
          <div class="input__clear with-icon" (click)="clearSearch()"></div>
        </div>
      </div>
    </div>
    <div class="header__controls header__controls-nosearch">
      <a routerLink="/genres" class="header__control">
        <div class="header__control-icon icon-music"></div>
        <div class="header__control-name">{{ 'header.catalog' | translate }}</div>
      </a>
      <a href="https://beeline.ru/customers/products/mobile/services/details/privet/" target="_blank" class="header__control">
        <div class="header__control-icon icon-info"></div>
        <div class="header__control-name">{{ 'header.about' | translate }}</div>
      </a>
      <div class="header__button" *ngIf="!isLoggedIn">
        <div class="button button_size_m button_type_dark" (click)="openLogin()">{{ 'header.login' | translate }}</div>
      </div>
      <div class="header__control" *ngIf="isLoggedIn">
        <div #menuTrigger class="header__control-menu-trigger" (click)="toggleMenu()">
          <div class="header__control-icon icon-profile-approved"></div>
          <div class="header__control-name">{{ msisdn | mask: '+0 000 000-00-00' }}</div>
        </div>

        <div #menuContainer class="header__control-menu" [style.display]="menuOpened ? 'block' : 'none'">
          <a routerLink="/subscriber/subscriptions" class="header__control-menu-item">
            <div class="header__control-menu-icon icon-menu-trust"></div>
            <div class="header__control-menu-text">{{ 'header.subscriptions' | translate }}</div>
          </a>
          <a routerLink="/subscriber/rules" class="header__control-menu-item" *ngIf="privetSubscription">
            <div class="header__control-menu-icon icon-menu-sound"></div>
            <div class="header__control-menu-text">{{ 'header.rules' | translate }}</div>
          </a>
          <a routerLink="/subscriber/melodies" class="header__control-menu-item">
            <div class="header__control-menu-icon icon-menu-music"></div>
            <div class="header__control-menu-text">{{ 'header.my-melodies' | translate }}</div>
          </a>
          <a routerLink="/subscriber/favorites" class="header__control-menu-item">
            <div class="header__control-menu-icon icon-menu-star"></div>
            <div class="header__control-menu-text">{{ 'header.favorites' | translate }}</div>
          </a>
          <a routerLink="/subscriber/ugc" class="header__control-menu-item">
            <div class="header__control-menu-icon icon-menu-add"></div>
            <div class="header__control-menu-text">{{ 'header.ugc' | translate }}</div>
          </a>
          <span class="header__control-menu-item header__control-menu-item-logout" (click)="openLogout()">
            <div class="header__control-menu-icon icon-menu-logout"></div>
            <div class="header__control-menu-text">{{ 'header.logout' | translate }}</div>
          </span>
        </div>

      </div>
    </div>
    <div class="header__controls header__controls-search">
      <div class="header__button" (click)="search()">
        <div class="button button_size_m">{{ 'header.search-btn' | translate }}</div>
      </div>
      <div class="header__button">
        <div class="button button_size_m button_type_light header__search-close" (click)="closeHeader()">{{ 'header.close-btn' | translate }}</div>
      </div>
    </div>
  </div>
</header>

<header class="header-mobile" [class.header-opened]="headerOpened">
  <div class="container container_type_header-mobile">
    <div #mobileMenuTrigger class="header-mobile__control" (click)="toggleMenu()">
      <div class="header-mobile__button icon icon-menu"></div>
    </div>
    <div class="header-mobile__control" (click)="openHeader()">
      <span class="header-mobile__button icon icon-search"></span>
    </div>
    <div class="header-mobile__control">
      <a routerLink="/" class="logo"></a>
    </div>
    <div class="header-mobile__control">
      <a routerLink="/subscriber/melodies" class="header-mobile__button icon" [class.icon-profile]="!isLoggedIn" [class.icon-profile-approved]="isLoggedIn"></a>
    </div>
    <div class="header-mobile__control">
      <a routerLink="/genres" class="header-mobile__button icon icon-music"></a>
    </div>
  </div>
  <div class="container container_type_header-mobile-search">
    <div class="header-mobile__back header__search-close with-icon" (click)="closeHeader()"></div>
    <div class="header__search">
      <div class="input input_width_auto input_size_m">
        <div class="input__container">
          <div class="input__icon icon-search"></div>
          <input #searchInput type="text" placeholder="{{ 'header.search-placeholder' | translate }}" value="" class="input__input"
                 [value]="searchText"
                 (keydown)="onKeyDown($event)"
                 (input)="onInputChange($event)" (keyup.enter)="search()" (keyup.shift.enter)="search()" maxlength="100"/>
          <div class="input__clear with-icon" (click)="clearSearch()"></div>
        </div>
      </div>
    </div>
    <div class="header__controls header__controls-search">
      <div class="header__button" (click)="search()">
        <div class="button button_size_m">{{ 'header.search-btn' | translate }}</div>
      </div>
    </div>
  </div>
</header>
<div #mobileMenuContainer class="header-mobile-menu" [style.display]="menuOpened ? 'block' : 'none'">
  <div class="header-mobile-menu__topline">
    <div class="header-mobile-menu__topline-part">
      <a routerLink="" (click)="openCorpLogin()" class="header-mobile-menu__topline-link">{{ 'top-line.corporate-login' | translate }}</a>
    </div>
    <div class="header-mobile-menu__topline-part">
      <a href="https://beeline.ru/customers/products/" class="header-mobile-menu__topline-link">{{ 'top-line.customers' | translate }}</a>
      <a href="https://beeline.ru/business/main/" class="header-mobile-menu__topline-link">{{ 'top-line.business' | translate }}</a>
      <a href="https://beeline.ru/customers/products/mobile/services/details/privet/" target="_blank" class="header-mobile-menu__topline-link">{{ 'header.about' | translate }}</a>
    </div>
  </div>
  <div class="header-mobile-menu-menu">
    <a routerLink="/subscriber/subscriptions" class="header-mobile-menu__link with-icon">
      <div class="header-mobile-menu__link-icon icon-menu-trust"></div>
      <div class="header-mobile-menu__link-text">{{ 'header.subscriptions' | translate }}</div>
    </a>
    <a routerLink="/subscriber/rules" class="header-mobile-menu__link with-icon" *ngIf="privetSubscription">
      <div class="header-mobile-menu__link-icon icon-menu-sound"></div>
      <div class="header-mobile-menu__link-text">{{ 'header.rules' | translate }}</div>
    </a>
    <a routerLink="/subscriber/melodies" class="header-mobile-menu__link with-icon">
      <div class="header-mobile-menu__link-icon icon-menu-music"></div>
      <div class="header-mobile-menu__link-text">{{ 'header.my-melodies' | translate }}</div>
    </a>
    <a routerLink="/subscriber/favorites" class="header-mobile-menu__link with-icon">
      <div class="header-mobile-menu__link-icon icon-menu-star"></div>
      <div class="header-mobile-menu__link-text">{{ 'header.favorites' | translate }}</div>
    </a>
    <a routerLink="/subscriber/ugc" class="header-mobile-menu__link with-icon">
      <div class="header-mobile-menu__link-icon icon-menu-add"></div>
      <div class="header-mobile-menu__link-text">{{ 'header.ugc' | translate }}</div>
    </a>
  </div>
  <div class="header-mobile-menu-logout" *ngIf="isLoggedIn">
    <span class="header-mobile-menu__link" (click)="openLogout()">
      <div class="header-mobile-menu__link-icon icon-menu-logout"></div>
      <div class="header-mobile-menu__link-text">{{ 'header.logout' | translate }}</div>
    </span>
  </div>
</div>

<div class="cookie" *ngIf="showCookieBanner">
  <div class="cookie__text" [innerHtml]="'text-cookie.agreement' | translate:{appUrl: appUrl}"></div>
  <div class="cookie__separator"></div>
  <div class="button button_type_cookie" (click)="acceptCookies()">{{'text-cookie.agree' | translate}}</div>
</div>
